import type { PaginationArguments, PaginationPageInfo } from "#gen/common/v1/pagination_pb.js";
import { SearchService, type Filter, type Result } from "#gen/search/v2/search_pb.js";
import { createClient, type ClientOptions } from "#lib/api/api.js";
import { handleError } from "#lib/api/error.js";
import { PUBLIC_URLS } from "#lib/url.js";
import type { CallOptions, Client } from "@connectrpc/connect";

export interface SearchResultList {
	results: Result[];
	pageInfo?: PaginationPageInfo;
}

export class SearchClient {
	private client: Client<typeof SearchService>;

	constructor(options?: () => ClientOptions) {
		this.client = createClient(PUBLIC_URLS.search || "/", SearchService, options);
	}

	async search(orgId: string, workspaceId: string, query: string, filter?: Filter, pagination?: PaginationArguments): Promise<SearchResultList> {
		try {
			const res = await this.client.search({
				orgId,
				workspaceId,
				query,
				filter,
				pagination,
			});
			return res;
		} catch (e) {
			throw handleError(e);
		}
	}
	async autocomplete(orgId: string, workspaceId: string, query: string, options?: CallOptions): Promise<Result[]> {
		try {
			const res = await this.client.autocomplete(
				{
					orgId,
					workspaceId,
					query,
				},
				options,
			);
			return res.results;
		} catch (e) {
			throw handleError(e);
		}
	}
}
